<template>
    {{ label }}:
    <span v-for="participant, index in participants" :key="participant.id">
        <span v-if="index > 0">; </span>
        {{ participant.display_name }} <TelephoneNumber :phoneNumber="participant.registration_phone_number" />
    </span>
</template>

<script>
import TelephoneNumber from '@/components/TelephoneNumber'

export default {
    name: 'SessionParticipants',

    components: {
        TelephoneNumber,
    },

    created() {
        switch(this.participantType) {
            case 'facilitators':
                this.participants = this.session.facilitators
                break

            case 'tech_facilitators':
                this.participants = this.session.tech_facilitators
                break

            case 'captioners':
                this.participants = this.session.captioners
                break

            case 'translators':
                this.participants = this.session.translators
                break            
        }

        this.label = this.participantType.replace('_', ' ')
        this.label = this.label.charAt(0).toUpperCase() + this.label.slice(1)
        if (this.participants.length == 1) {
            this.label = this.label.substring(0, this.label.length - 1)
        }
    },

    data() {
        return {
            label: '',
            participants: [],
        }
    },

    props: {
        participantType: {
            type: String,
            required: true,
        },
        session: {
            type: Object,
            required: true,
        },
    },
}
</script>
